import React from "react";

const Logout = props => (
  <svg viewBox="0 0 20 15" fill="none" {...props}>
    <path
      d="M1.875 0C.82 0 0 .86 0 1.875v11.25C0 14.18.82 15 1.875 15h5.156a.475.475 0 00.469-.469v-.312a.504.504 0 00-.469-.469H1.875a.617.617 0 01-.625-.625V1.875c0-.313.273-.625.625-.625h5.156A.475.475 0 007.5.781V.47A.504.504 0 007.031 0H1.875zm10.898.781l-.312.274a.53.53 0 000 .664l5.156 5.117H6.72a.475.475 0 00-.469.469v.39c0 .274.195.47.469.47h10.898L12.5 13.32a.45.45 0 000 .664l.273.274c.157.195.47.195.665 0l6.406-6.406a.45.45 0 000-.665L13.437.782c-.195-.195-.507-.195-.664 0z"
      fill="currentColor"
    />
  </svg>
);

export default Logout;
